module.exports = function() {
  return new Worker(__webpack_public_path__ + "03873bd360d93cc840d2.worker.js");
};